import React, { useEffect, useState } from "react";
import BellIcon from "react-bell-icon";
import { Link } from "react-router-dom";
import {
  getLocalTimeFormatted,
  phoneFormat,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";

export default function CustomerOrder(props) {
  const { cartItems, cart, tableNum, tableTemp, setTableTemp, ctxDispatch } =
    props;

  const [alertItemExist, setAlertItemExist] = useState(false);

  useEffect(() => {
    setAlertItemExist(
      cart.cartItems.filter((item) => !item.delivered && item.alert).length > 0
    );
  }, [cart]);

  return (
    <Link
      to=""
      className="textDecorationNone"
      onClick={() => {
        setTableTemp(tableNum);

        ctxDispatch({
          type: "SELECT_TABLE",
          payload: tableNum,
        });
      }}
    >
      <div className={"hoverOrderOfCustomerBlue"}>
        <div
          className={
            cart.tableNum === tableTemp
              ? "rounded backgroundBlue text-bold"
              : "rounded  text-bold"
          }
          style={{
            margin: "0.3rem",
            marginBottom: "0px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            className={`${"border border-success text-white rounded-start p-1 ps-2 pe-2"}`}
            style={{
              height: "60px",
              aspectRatio: "2/1",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {alertItemExist && (
              <div
                className="border border-danger rounded-circle bg-white"
                style={{
                  position: "absolute",
                  top: "2px",
                  right: "5px",
                  width: "22px",
                  height: "22px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <BellIcon
                  active={false}
                  animate={true}
                  color="#dc3545"
                  width="17"
                  height="17"
                />
              </div>
            )}

            {!alertItemExist && (
              <i
                className="fa fa-check text-white"
                style={{
                  position: "absolute",
                  top: "2px",
                  right: "5px",
                }}
              ></i>
            )}

            <div>
              <span>
                {cart.user
                  ? cart.user.name
                  : cart.description || cart.cartItems[0].customerName}
              </span>
            </div>
            {cart.user && (
              <div className="small-font">
                {phoneFormat(cart.user.phone.substring(3))}
              </div>
            )}
          </div>

          <div
            className="border border-success p-1 ps-2 pe-2"
            style={{
              height: "60px",
              aspectRatio: "1/1",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <span className="text-warning">
              {turkishCurrencyFormatterNoPrecision(
                cartItems
                  .filter((x) => !x.isGift)
                  .reduce(
                    (a, c) =>
                      a +
                      c.quantity *
                        (c.feature ? c.feature.price + c.price : c.price),
                    0
                  )
              )}
            </span>
            <div className="small-font text-white">
              {cartItems.length > 0 &&
                getLocalTimeFormatted(cartItems[0].createdAt)}
            </div>
          </div>

          <div
            className="border border-success rounded-end  text-white p-1 ps-2 pe-2 "
            style={{
              height: "60px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              flexBasis: "100%",
              fontWeight: "100",
            }}
          >
            <span>
              {tableNum <= 300
                ? "Masa " + tableNum + "'den gelen sipariş"
                : cart.user && (
                    <div>
                      {cart.cartItems[0]?.address?.address +
                        " " +
                        cart.cartItems[0]?.address?.county +
                        " " +
                        cart.cartItems[0]?.address?.city}
                    </div>
                  )}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
